import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from '@reduxjs/toolkit/query/react';
import rootReducer from "./reducers";
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// import { reduxMiddlewares } from "./reducers";
import manageFolderApi from "./apis/manage-folder";
import manageSaveSearchApi from "./apis/manage-save-search";
import loginApi from "./apis/login";
// import masterDataApi from "./apis/get-master-data";
import folderManagementApi from "./apis/folder-management";

export const reduxMiddlewares = [
      // add middlewares here ...
      manageFolderApi.middleware,
      manageSaveSearchApi.middleware,
      loginApi.middleware,
      // masterDataApi.middleware,
      folderManagementApi.middleware
  ]

// Get the RTK Query middleware with auth check
const baseQueryWithAuthCheck = fetchBaseQuery({
  baseUrl: window.location.origin,
  credentials: "include"
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware:any) => {
    // Get the default middleware from RTK
    const defaultMiddleware = getDefaultMiddleware({
      serializableCheck: false
    });

    // Combine RTK Query middleware and Redux middlewares
    const allMiddleware = [...defaultMiddleware, ...reduxMiddlewares];

    return allMiddleware;
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Pass only the dispatch function to setupListeners
setupListeners(store.dispatch);
